import UpdateIOUAdjustmentExport from "../UpdateIOUAdjustmentExport/UpdateIOUAdjustmentExport";

const ViewIOUAdjustmentExport = (props) => {
  return <UpdateIOUAdjustmentExport {...props} viewMode={true} />;
};

export default ViewIOUAdjustmentExport;
